import {
  request
} from '@/utils/request.js'

const getGamesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/games/games',
    method: 'GET',
    noToken: true,
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getGameById = (id, data, callback, errCallback, finCallback) => {
  request({
    url: `/games/games/${id}`,
    params: data,
    noToken: true,
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getSubmitPlayerInfo = (data, callback, errCallback, finCallback) => {
  request({
    url: `/games/submit_player_info`,
    data: data,
    method: 'POST',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const doEnroll = (gameId, data, callback, errCallback, finCallback) => {
  request({
    url: `/games/enroll/${gameId}`,
    data: data,
    method: 'POST',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getGameResult = (data, callback, errCallback, finCallback) => {
  request({
    url: `/games/results`,
    params: data,
    method: 'GET',
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

export {
  getGameById,
  getGamesList,
  getSubmitPlayerInfo,
  doEnroll,
  getGameResult
}


// WEBPACK FOOTER //
// ./src/servers/games.js